export const carousel = () => {
    window.addEventListener('slideChange', (event) => {
        let carousel = event.detail;
        carousel = document.querySelector('#' + carousel);
        if (carousel && carousel.classList.contains('carousel__images')) {
            let section = carousel.getAttribute('data-parent-section');
            section = document.querySelector('[data-section-id="' + section + '"]');
            const infoSlides = section.querySelectorAll('.info__slide');
            infoSlides.forEach((slide) => {
                slide.classList.remove('info__slide--show');
            });
            let currentSlide = section.querySelector('.slideshow__slide.is-selected');
            currentSlide = currentSlide.getAttribute('data-slide-image');
            const slideInfo = section.querySelector('.info__slide[data-slide-info="' + currentSlide + '"]');
            slideInfo.classList.add('info__slide--show');
        }
    });
};
